
// Encoding function
const encodeData = (data) => {
    try {
        // Convert the data to a JSON string if it's not already.  This handles objects and arrays.
        const dataString = typeof data === 'string' ? data : JSON.stringify(data);

        // Use btoa() for Base64 encoding.  This works well for most data.
        const encodedData = btoa(unescape(encodeURIComponent(dataString))); // Handle special characters

        return encodedData;
    } catch (error) {
        console.error("Error encoding data:", error);
        return null; // Or handle the error as needed
    }
}

// Decoding function
const decodeData = (encodedData) => {
    try {
        if (!encodedData) return null; // Handle null or undefined input
        const decodedDataString = decodeURIComponent(escape(atob(encodedData)));
        // Try to parse as JSON. If it fails, it's likely a string.
        try {
            return JSON.parse(decodedDataString);
        } catch (jsonError) {
            return decodedDataString; // It's a regular string
        }
    } catch (error) {
        console.error("Error decoding data:", error);
        return null;
    }
}


const handleKeyPress = (event) => {

    const { key, keyCode } = event;

    const isNUMBERS = (keyCode >= 48 && keyCode <= 57);


    //const isSpace = key === ' ';
    const isBackspace = keyCode === 8;
    const isEnter = keyCode === 13;
    const isLeftArrow = keyCode === 37;
    const isUpArrow = keyCode === 38;
    const isRightArrow = keyCode === 39;
    const isDownArrow = keyCode === 40;

    if (
        !isNUMBERS &&
        !isBackspace &&
        !isEnter &&
        !isLeftArrow &&
        !isUpArrow &&
        !isRightArrow &&
        //!isSpace &&
        !isDownArrow
    ) {
        event.preventDefault();
    }
}

const handleKeyNumberwithDotPress = (event) => {
    const { keyCode } = event;

    const isNUMBERS = (keyCode >= 48 && keyCode <= 57);
    const isDot = keyCode === 190 || keyCode === 110; // . or . on numpad
    const isBackspace = keyCode === 8;
    const isEnter = keyCode === 13;
    const isLeftArrow = keyCode === 37;
    const isUpArrow = keyCode === 38;
    const isRightArrow = keyCode === 39;
    const isDownArrow = keyCode === 40;

    if (
        !isNUMBERS &&
        !isDot &&
        !isBackspace &&
        !isEnter &&
        !isLeftArrow &&
        !isUpArrow &&
        !isRightArrow &&
        !isDownArrow
    ) {
        event.preventDefault();
    }
}


const removeCommasAndConcatenate = (str) => {
    return String(str).replace(/,/g, '');
}

const AddCommas = (nStr) => {
    let value = removeCommasAndConcatenate(nStr);
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const handleKeyPressPanCard = (event) => {
    const { key, keyCode } = event;

    //const isLetter = (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122);    
    const isLetter = (keyCode >= 65 && keyCode <= 90);
    //const isSpace = key === ' ';
    const isNUMBERS = (keyCode >= 48 && keyCode <= 57);

    const isBackspace = keyCode === 8;
    const isEnter = keyCode === 13;
    const isLeftArrow = keyCode === 37;
    const isUpArrow = keyCode === 38;
    const isRightArrow = keyCode === 39;
    const isDownArrow = keyCode === 40;

    if (
        !isNUMBERS &&
        !isLetter &&       
        !isBackspace &&
        !isEnter &&
        !isLeftArrow &&
        !isUpArrow &&
        !isRightArrow &&
        !isDownArrow
    ) {
        event.preventDefault();
    }


};

const handleKeyPressString = (event) => {
    const { key, keyCode } = event;

    //const isLetter = (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122);    
    const isLetter = (keyCode >= 65 && keyCode <= 90);
    const isSpace = key === ' ';
    const isBackspace = keyCode === 8;
    const isEnter = keyCode === 13;
    const isLeftArrow = keyCode === 37;
    const isUpArrow = keyCode === 38;
    const isRightArrow = keyCode === 39;
    const isDownArrow = keyCode === 40;

    if (
        !isLetter &&
        !isSpace &&
        !isBackspace &&
        !isEnter &&
        !isLeftArrow &&
        !isUpArrow &&
        !isRightArrow &&
        !isDownArrow
    ) {
        event.preventDefault();
    }


};

function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

const handleScrollToTop = () => {
    // console.log("Scrolling to top");
    // window.scrollTo(0, 0); // Scroll to the top of the page
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

function cleanFloat(input) {
    if (input < 0) { return 0; }
    return parseInt(input).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getBeforeDecimal(floatValue) {
    const [integerPart] = floatValue.toString().split(".");
    return parseInt(integerPart);
}

function getMonthName(monthNumber) {
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    if (monthNumber < 1 || monthNumber > 12) {
        throw new Error("Invalid month number. Must be between 1 and 12.");
    }
    return months[monthNumber - 1];
}

function convertDatePickerDate(datepickerDate) {
    // Assuming datePickerValue is in the format "YYYY-MM-DD" (default for <input type="date">)
    const dateObject = new Date(datepickerDate);

    if (isNaN(dateObject)) {
        console.error("Invalid date format from datepicker:", datepickerDate);
        return null; // Or handle the error as needed
    }

    // Get the year, month, and day.
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(dateObject.getDate()).padStart(2, '0');

    // Get the hours, minutes, and seconds.
    const hours = String(dateObject.getHours()).padStart(2, '0');
    const minutes = String(dateObject.getMinutes()).padStart(2, '0');
    const seconds = String(dateObject.getSeconds()).padStart(2, '0');

    // Construct the C# DateTime format string (YYYY-MM-DD HH:mm:ss).
    const cSharpFormattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return cSharpFormattedDate;
}

function convertToUpperCaseOnKeyDown(event) {
    const inputElement = event.target;
    inputElement.value = inputElement.value.toUpperCase();
  }


const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};




export {
    decodeData,
    encodeData,
    handleKeyPress,
    removeCommasAndConcatenate,
    handleKeyPressString,
    isValidEmail,
    handleScrollToTop,
    cleanFloat,
    getBeforeDecimal,
    AddCommas,
    getMonthName,
    convertDatePickerDate,
    convertToUpperCaseOnKeyDown,
    handleKeyPressPanCard,
    scrollToTop,
    handleKeyNumberwithDotPress
}
